import { useSanctumClient } from "#imports";
import { ApiServiceContainer } from "~/services/ApiServiceContainer";

export default defineNuxtPlugin(() => {
    const client = useSanctumClient();

    // async onResponseError({ response }) {
    //             if (process.client) {
    //                 if (response.status === 500) {
    //                     const source = ref(JSON.stringify(response._data));
    //                     const clipboard = useClipboard({ source });
    //                     const notification: Partial<Notification> = {
    //                         id: "server_error",
    //                         title: "Server Error",
    //                         description:
    //                             response._data && response._data.message
    //                                 ? response._data.message
    //                                 : undefined,
    //                         icon: "i-heroicons-exclamation-triangle",
    //                         color: "red",
    //                         timeout: 5000,
    //                         actions:
    //                             typeof response._data === "object" &&
    //                             clipboard.isSupported.value
    //                                 ? [
    //                                       {
    //                                           label: "Copy Error",
    //                                           click: () =>
    //                                               clipboard.copy(source.value),
    //                                       },
    //                                   ]
    //                                 : [],
    //                         callback: () => {
    //                             useErrorNotification().value = false;
    //                         },
    //                     };
    //
    //                     if (useErrorNotification().value) {
    //                         useToast().update("server_error", notification);
    //                     } else {
    //                         useErrorNotification().value = true;
    //
    //                         useToast().add(notification);
    //                     }
    //                 }
    //             }
    //
    //             if (response.status === VALIDATION_ERROR_STATUS) {
    //                 throw new ApiError(response._data);
    //             }
    //         }
    return {
        provide: {
            api: new ApiServiceContainer({
                client,
                baseUri: "",
            }),
        },
    };
});
